// import consts from "@/consts.js";
import Request from './request';
// import store from '@/store.js'
// import i18n from '@/i18n'
// import snackbar from '@/plugins/snackbar'

async function fetch() {
    return Request('get', "api/presale-templates");
}


async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
  if (id)
      return Request('patch', "api/presale-templates/edit?id=" + id, data);
  else
      return Request('post', "api/presale-templates/add", data);
}

async function copy(data) {
  return Request('post', "api/presale-templates/copy", data);
}

async function edit(data) {
  return Request('patch', "api/presale-templates/edit", data);
}

async function del(id) {
  return Request('patch', "api/presale-templates/delete/" + id);
}

async function fetchPresales(id,data) {
  return Request('get', "api/presales/view-by-template/" + id,data);
}

async function batchSave(data) {
  return Request('post', "api/presales/batch-save", data);
}

async function Export(data) {
  return  Request('get', "api/presale-templates/export",data)
}

async function Import(data) {// 导入
  return Request('post', "api/presale-templates/import",data)
}

export default {
  fetch,
  copy,
  edit,
  del,
  fetchPresales,
  batchSave,
  Import,
  Export,
  save,
};